import axios from 'axios'
import router from '../router'

const api = axios.create({
  baseURL: '', // 使用当前页面的origin，通过代理转发到 http://127.0.0.1:8000
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器，处理 401 错误
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // 清除 token
      localStorage.removeItem('access_token')
      // 跳转到登录页
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

export default api
